import { Swiper, Pagination, Navigation } from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
    const curatedCarousels = document.querySelectorAll<HTMLElement>('.curated-swiper');
    curatedCarousels.forEach((carouselPanel) => {
        initCuratedSwiper(carouselPanel);
    });
});

function initCuratedSwiper(carouselPanel: HTMLElement) {
    const slides = carouselPanel.querySelectorAll('.curated-slide');
    const slideCount = slides.length;
    const hasMultipleSlides = slideCount > 1;

    const pageDot = carouselPanel.querySelector<HTMLElement>('.curated-pagination');
    const paginationClasses = [
        '!left-1/2',
        '!w-fit',
        '!rounded-2xl',
        '!px-2',
        '!py-1',
        '!transform',
        '-translate-x-1/2',
        '!bg-gray-200',
        '!bg-opacity-80',
    ];
    pageDot.classList.add(...paginationClasses);

    const titleDiv = carouselPanel.querySelector<HTMLElement>('.title');
    const titleHeight = titleDiv ? titleDiv.offsetHeight : 0;

    const prevButton = carouselPanel.querySelector<HTMLElement>('.swiper-button-prev');
    const nextButton = carouselPanel.querySelector<HTMLElement>('.swiper-button-next');

    if (prevButton && titleHeight > 0) {
        prevButton.style.transform = `translateY(${titleHeight / 2}px)`;
    }
    if (nextButton && titleHeight > 0) {
        nextButton.style.transform = `translateY(${titleHeight / 2}px)`;
    }

    const swiperInstance = new Swiper(carouselPanel, {
        modules: [Pagination, Navigation],
        loop: hasMultipleSlides,
        navigation: hasMultipleSlides
            ? {
                  prevEl: '.swiper-button-prev',
                  nextEl: '.swiper-button-next',
              }
            : false,
        pagination: hasMultipleSlides
            ? {
                  clickable: true,
                  el: '.curated-pagination',
                  bulletClass: 'swiper-pagination-bullet',
                  bulletActiveClass: 'swiper-pagination-bullet-active bg-black',
              }
            : false,
        spaceBetween: 20,
        slidesPerView: 1,
    });

    if (!hasMultipleSlides) {
        const prevButton = carouselPanel.querySelector<HTMLElement>('.swiper-button-prev');
        const nextButton = carouselPanel.querySelector<HTMLElement>('.swiper-button-next');
        const paginationEl = carouselPanel.querySelector<HTMLElement>('.curated-pagination');

        if (prevButton) prevButton.style.display = 'none';
        if (nextButton) nextButton.style.display = 'none';
        if (paginationEl) paginationEl.style.display = 'none';
    }

    swiperInstance.update();
}

export default initCuratedSwiper;
